import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { groupInput, input, InputProvider } from "@redotech/ui/form";
import classNames from "classnames";
import { memo } from "react";
import { ImsStatus } from "./general";

export const catalogForm = groupInput({
  syncEnabled: input<boolean>(),
  catalogEnabled: input<boolean>(),
  catalogSourceOfTruthStatus: input<ImsStatus>(),
});

export type CatalogForm = InputProvider.Form<typeof catalogForm>;

export type CatalogValue = InputProvider.Value<typeof catalogForm>;

export const catalogDefault: CatalogValue = {
  syncEnabled: false,
  catalogEnabled: false,
  catalogSourceOfTruthStatus: "read-only" as const,
};

export const CatalogCard = memo(function CatalogCard({
  input,
}: {
  input: CatalogForm;
}) {
  const { syncEnabled, catalogEnabled, catalogSourceOfTruthStatus } =
    input.inputs;

  const isSourceOfTruth =
    catalogSourceOfTruthStatus.value === "source-of-truth";

  const handleSourceOfTruthToggle = (value: boolean) => {
    catalogSourceOfTruthStatus.setValue(
      value ? "source-of-truth" : "read-only",
    );
  };

  return (
    <Card title="Product Catalog">
      <section className={gridCss.grid}>
        <div className={gridCss.span12}>
          <div className={gridCss.grid}>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="Enable product and inventory sync from Shopify"
                label="Sync Enabled"
                setValue={(value) => syncEnabled.setValue(value)}
                size="sm"
                value={syncEnabled.value ?? false}
              />
            </div>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="Enable catalog management features"
                label="Catalog Enabled"
                setValue={(value) => catalogEnabled.setValue(value)}
                size="sm"
                value={catalogEnabled.value ?? false}
              />
            </div>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="When enabled, Redo is the source of truth for catalog data"
                disabled={!catalogEnabled.value}
                label="Catalog Source of Truth"
                setValue={handleSourceOfTruthToggle}
                size="sm"
                value={isSourceOfTruth}
              />
            </div>
          </div>
        </div>
      </section>
    </Card>
  );
});
